import React from "react";
import { icons } from "src/statics/icons";
import "./review-card.component.scoped.sass";
import { ReviewCardProps } from "src/types/review-card-props";
import moment from "moment";
import { ReviewStarsComponent } from "../review-stars/review-stars.component";

export const ReviewCardComponent = (props: ReviewCardProps) => {
  const { homeDarkIco } = icons;
  const { data } = props;
  const dateRender = moment(new Date(data.date)).format("dd. MMMM YYYY");
  return (
    <div className="review-card">
      <div className="building">
        <div className="left">
          <img alt="home" height="20px" src={homeDarkIco} />
          <span>{data.building}</span>
        </div>
        <div className="right">
          <div className="review">
            <ReviewStarsComponent
              withText={false}
              count={data.rate}
              total={data.total}
            />
          </div>
        </div>
      </div>
      <div className="devider">
        <div className="liner" />
        <div className="date">{dateRender}</div>
      </div>
      <div className="description">{data.comment}</div>
    </div>
  );
};
